import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import store from '../../store'

export default (passenger: ClientPassengerInterface) => {
  const state: ReduxStoreInterface = store.getState()
  const bookedPassengerIds = state.passengersBooked.allIds

  return !bookedPassengerIds.includes(passenger.id)
}
